import * as c from "purify-ts/Codec";
import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { Source } from "trader.ts/types/source";
import { Form, textBox } from "trader.ts/ui.forms";
import { evaluationid } from "../../../sql/classy/types";
import * as style from "../../../styles/style.css.classes";
import { renderDownloadExampleSection } from "../../client/download_example_button";
import { fileInputField } from "../../client/fileinput";
import { renderSaveButton } from "../../client/savebutton";
import { localStorageSpec } from "../../lib/localstorage";
import { wrapInParentheses } from "../../render";
import * as routes from "../../routes";

const evaluationLS: localStorageSpec<{
  description: string;
  id: evaluationid;
}> = {
  key: "classy_school_evaluation_example_id",
  codec: c.Codec.interface({
    description: c.string,
    id: c.number as unknown as c.Codec<evaluationid>,
  }),
};

export function render(opts: {
  header_filename: string | null;
  background_filename: string | null;
  header_text_color: string;
  body_text_color: string;
}): HTMLElement | HTMLElement[] {
  const form = new Form({})
    .addField("header_new_file", [], async () => {
      return fileInputField({
        initial: opts.header_filename
          ? { filename: opts.header_filename }
          : null,
        style: "min-width: unset",
        label:
          "Achtergrond hoofding" +
          " " +
          wrapInParentheses("Resolutie: 2380px × 1024px"),
        initiallabel: opts.header_filename
          ? "Nieuw"
          : "Upload achtergrond hoofding",
        selectedlabel: "Geselecteerd",
      });
    })
    .addField("background_new_file", [], async () => {
      return fileInputField({
        initial: opts.background_filename
          ? { filename: opts.background_filename }
          : null,
        style: "min-width: unset",
        label:
          "Achtergrond" +
          " " +
          wrapInParentheses("Resolutie volledige pagina: 2380px x 3368px"),
        initiallabel: opts.background_filename
          ? "Nieuw"
          : "Upload achtergrond",
        selectedlabel: "Geselecteerd",
      });
    })
    .addField("header_text_color", [], () => {
      return textBox({
        initialVal: opts.header_text_color || "",
        label: "Kleur tekst hoofding",
        type: "color",
      });
    })
    .addField("body_text_color", [], () => {
      return textBox({
        initialVal: opts.body_text_color || "",
        label: "Kleur tekst onderdelen",
        type: "color",
      });
    })
    .build();

  const showDownloadExamplePopupS = new Source(false);

  return (
    <div>
      <section className={style.equal_columns}>
        <div>{form.render()}</div>
        <div>
          <label for="">{"Voorbeeld"}</label>
          {renderDownloadExampleSection({
            findOptions: ({ searchstring }) =>
              rpc(routes.findEvaluationSpec, undefined, { searchstring }),
            showOption: (t) => t.description,
            makeDownloadLink: (t) =>
              routes.downloadEvaluationPdfSpec.route.link({
                evaluationid: t.id,
              }),
            inputLabel: "Zoek evaluatie",
            lsSpec: evaluationLS,
            close: () => showDownloadExamplePopupS.set(false),
          })}
        </div>
      </section>

      <div style="text-align: right;">
        <div>
          {renderSaveButton({
            formS: form.s,
            save: (v) => {
              return rpc(routes.saveEvaluationPdfConfigSpec, undefined, {
                header_text_color: v.header_text_color.trim() || null,
                body_text_color: v.body_text_color.trim() || null,
                background_new_file: v.background_new_file,
                header_new_file: v.header_new_file,
              });
            },
            reload: true,
          })}
        </div>
      </div>
    </div>
  );
}
